export class DashboardConstants {
    static cellSizing = 125;
}
